import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Structure } from 'app/shared/models/class/structure/structure';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { StructureService } from 'app/shared/services/structure/structure.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-admin-structure',
  templateUrl: './admin-structure.component.html',
  styleUrls: ['./admin-structure.component.scss']
})
export class AdminStructureComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['structureName', 'details', 'edit'];
  dataSource: MatTableDataSource<Structure>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  searchForm: UntypedFormGroup;
  valueInput: string;
  structures: Structure[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private structureService: StructureService,
    private router: Router,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getStructures();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  goEdit({ structureKey }): void {
    this.router.navigate(['/admin/structure-details'], { queryParams: { structureKey, update: true } });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private getStructures(): void {
    this.structureService.getStructure().subscribe({
      next: structures => {
        this.structures = structures;
        this.dataSource = new MatTableDataSource(structures);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

      }
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

}
